// @core/api/endpoints/authn/revoke_token.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  RevokeTokenRequest,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Revoke OAuth2 token
 * Invalidates an access or refresh token, preventing further use. Revoking a refresh token also invalidates all associated access tokens.
 */
export async function RevokeToken(
  data: RevokeTokenRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/oauth2/revoke`;
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
